import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_GROUP_FIELD_LIST } from "../../Actions/PatientAction";
import {
  CircularProgress,
  Grid,
  TextField,
  Checkbox,
  Box,
  Chip,
  Button,
} from "@mui/material";
import clsx from "clsx";
import Autocomplete from "@mui/material/Autocomplete";
import "../../Sass/Common.scss";
import { getEllipsisName } from "../../utils/generalUtils";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  GroupAutocompleteListbox: {
    padding: "0px !important",
    // marginTop: "45px !important",
  },
  addButton: {
    "&>button": {
      fontSize: "1rem",
      overflow: "hidden",
      [theme.breakpoints.between("1600", "1700")]: {
        fontSize: "0.9rem",
      },
      [theme.breakpoints.between("1500", "1600")]: {
        fontSize: "0.85rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
      [theme.breakpoints.between("1400", "1500")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "40px",
      },
      [theme.breakpoints.between("1300", "1400")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
      [theme.breakpoints.between("1200", "1300")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
      [theme.breakpoints.between("1100", "1200")]: {
        fontSize: "0.7rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
    },
  },
  addButtonDialog: {
    "&>button": {
      fontSize: "0.95rem",
      overflow: "hidden",
      [theme.breakpoints.between("1600", "1700")]: {
        fontSize: "0.9rem",
      },
      [theme.breakpoints.between("1500", "1600")]: {
        fontSize: "0.85rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
      [theme.breakpoints.between("1400", "1500")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "40px",
      },
      [theme.breakpoints.between("1300", "1400")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
      [theme.breakpoints.between("1200", "1300")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
      [theme.breakpoints.between("1100", "1200")]: {
        fontSize: "0.7rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "45px",
      },
    },
  },
  customTag: {
    maxWidth: "calc(60% - 6px) !important",
  },
}));

function GroupAutoComplete(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    groupFieldList,
    getGroupFieldListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    groupListFlag,
    helperText,
    error = false,
    buttonOptionTop,
    buttonTitle,
    handleButtonClick,
    maxVisibleChip = 1,
    dialog = false,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const classes = useStyles();
  const [selectGroup, setSelectGroup] = useState(
    multiple ? Object.values(value || {}) : value || {}
  );
  const [groupSearchString, setGroupSearchString] = useState("");
  const [isOpenGroupList, setIsOpenGroupList] = useState(false);
  const [setTargetGroup, entryGroup] = useIntersection({
    threshold: 0.1,
  });

  /** handle select group value  */
  useEffect(() => {
    if (multiple) {
      setSelectGroup(Object.values(value || {}));
    } else {
      setSelectGroup(value);
    }
  }, [value]);

  /** get data on entry group */
  useEffect(() => {
    if (entryGroup.isIntersecting && groupFieldList.loading === false) {
      let params = {
        offset: groupFieldList?.data?.list?.length || 0,
        ...(groupSearchString && { q: groupSearchString }),
      };
      if (isOpenGroupList) {
        getGroupFieldListAction(params);
      }
    }
  }, [entryGroup]);

  /** search data */
  const searchGroupDebounce = useRef(
    _.debounce((searchString, open) => {
      let params = {
        offset: 0,
      };
      if (searchString) {
        params.q = searchString;
      }
      if (open) {
        getGroupFieldListAction(params);
      }
    }, 500)
  );

  /** handle search group name  */
  const handleSearchGroupName = (newValue) => {
    setGroupSearchString(newValue);
    searchGroupDebounce.current(newValue, isOpenGroupList);
  };

  /** fetch group data */
  let fetchGroupData = () => {
    setIsOpenGroupList(true);
    let params = {
      offset: 0,
      ...(groupSearchString && { q: groupSearchString }),
    };
    getGroupFieldListAction(params);
  };

  /** handle change group listing */
  const handleChnageGroupListing = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((group) => {
        newList[group.g_id] = group;
      });
    } else {
      newList = newValue;
    }
    setSelectGroup(newValue);
    handleChange && handleChange(newList);
  };

  /** Filter options with a custom button at the top of the list */
  const filterOptions = (options) => {
    let result = [...options];
    if (buttonOptionTop && !result.some((option) => option.type === "button")) {
      result = [{ type: "button" }, ...result];
    }
    if (groupFieldList?.data?.list?.length < groupFieldList?.data?.total) {
      result.push("FinalOption");
    }
    if (groupFieldList?.data?.list?.length === 0) {
      result.push({
        g_name: `No option found`,
      });
    }
    return result || [];
  };

  return (
    <>
      <Autocomplete
        multiple={multiple}
        classes={{
          listbox: buttonOptionTop && classes.GroupAutocompleteListbox,
          option: "option",
          noOptions: "noOptions",
          tag: classes.customTag,
        }}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
        popoverProps={{
          style: {
            bottom: 0,
            overflowY: "auto",
          },
        }}
        disableCloseOnSelect={multiple}
        disabled={Boolean(disabled)}
        onOpen={fetchGroupData}
        onClose={() => {
          setIsOpenGroupList(false);
        }}
        noOptionsText={"No results found"}
        value={selectGroup}
        onChange={handleChnageGroupListing}
        options={groupFieldList?.data?.list || []}
        getOptionLabel={(option) => {
          return option.g_name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option?.g_id === value?.g_id;
        }}
        onInputChange={(event, newValue) => {
          handleSearchGroupName(newValue);
        }}
        filterOptions={filterOptions}
        renderOption={(props, option, { selected }) => {
          if (buttonOptionTop && option.type === "button") {
            return (
              <Grid
                container
                alignItems="center"
                className={
                  dialog
                    ? clsx("autoCompleteButton", classes.addButtonDialog)
                    : clsx("autoCompleteButton", classes.addButton)
                }
              >
                <Button
                  onClick={handleButtonClick}
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {buttonTitle}
                </Button>
              </Grid>
            );
          } else {
            return (
              <React.Fragment>
                {typeof option === "object" ? (
                  <Grid {...props} key={option?.g_id}>
                    {multiple && option.g_id && <Checkbox checked={selected} />}
                    {option.g_name}
                  </Grid>
                ) : (
                  <Grid
                    className="autoCompleteInputLoader"
                    ref={setTargetGroup}
                  >
                    <CircularProgress size={20} />
                  </Grid>
                )}
              </React.Fragment>
            );
          }
        }}
        getOptionDisabled={(option) => {
          if (option.g_name === "No option found") {
            return true;
          }
        }}
        renderTags={(tagValue, getTagProps) => {
          if (tagValue.length === maxVisibleChip) {
            return tagValue.map((option, index) => {
              return (
                <HtmlTooltipMain title={option?.g_name}>
                  <Chip
                    key={index}
                    label={`${option.g_name}`}
                    {...getTagProps({ index })}
                    size="small"
                  />
                </HtmlTooltipMain>
              );
            });
          } else {
            return (
              <Box display="flex" alignItems="center">
                {tagValue
                  .slice(0, groupListFlag === true ? maxValue : maxVisibleChip)
                  .map((option, index) => (
                    <HtmlTooltipMain title={tagValue[index]?.g_name}>
                      <Chip
                        label={`${getEllipsisName(tagValue[index].g_name, 8)}`}
                        {...getTagProps({ index: index })}
                        size="small"
                      />
                    </HtmlTooltipMain>
                  ))}
                {tagValue.length > maxVisibleChip && (
                  <HtmlTooltipMain
                    interactive={true}
                    title={
                      <Grid>
                        {tagValue.slice(maxVisibleChip).map((option, index) => (
                          <Box>{option.g_name}</Box>
                        ))}
                      </Grid>
                    }
                  >
                    <Box>
                      +{" "}
                      {tagValue.length -
                        Math.min(maxVisibleChip, tagValue.length)}{" "}
                      more
                    </Box>
                  </HtmlTooltipMain>
                )}
              </Box>
            );
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            InputLabelProps={{ required: false }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              endAdornment: (
                <React.Fragment>
                  {groupFieldList?.loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...other}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  groupFieldList: state.patient.groupFieldList,
});

const mapDispatchToProps = (dispatch) => ({
  getGroupFieldListAction: (payload) =>
    dispatch({ type: START_GROUP_FIELD_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupAutoComplete);
